module.exports = __webpack_public_path__ + "img/escudo_coepris.f8331f99.f8331f99.png";